import * as React from 'react';
import {Table, TableBody, TableCell, TableContainer, TableHead, TableRow} from '@mui/material';
import {datetimeFullToGui} from "../../helpers/date";
import {EllipsisTableCell} from "components/reports/EllipsisTableCell";
import {ReportDataType} from "pages/ReportsPage";
import {useAppTranslation} from "../../services/i18n";

interface TestAttemptsTableProps {
    data: ReportDataType['testAttempts'];
}

export const ReportTestAttemptsTable: React.FC<TestAttemptsTableProps> = ({data}) => {
    const t = useAppTranslation();

    return <TableContainer>
        <Table>
            <TableHead sx={{'& th': {backgroundColor: 'white'}}}>
                <TableRow sx={{backgroundColor: '#F5F5F5', '& .MuiTableCell-head': {color: '#8D8D8D', fontWeight: 'normal', borderTop: 'unset'}}}>
                    <TableCell>{t('reports.table.name')}</TableCell>
                    <TableCell>{t('reports.table.date')}</TableCell>
                    <TableCell>{t('reports.table.content')}</TableCell>
                    <TableCell>{t('reports.table.testName')}</TableCell>
                    <TableCell>{t('reports.table.passed')}</TableCell>
                    <TableCell>{t('reports.table.achievedPoints')}</TableCell>
                    <TableCell>{t('reports.table.maxPoints')}</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {data?.map((row, index) => (
                    <TableRow
                        key={`${row.test_attempt_id}-${index}`}
                        sx={{
                            '&:nth-of-type(odd)': {backgroundColor: '#FAFAFA'},
                            '&:hover': {backgroundColor: '#efefef'}
                        }}
                    >
                        <TableCell>{row.user_name}</TableCell>
                        <TableCell>
                            {datetimeFullToGui(row.test_created_at)}
                        </TableCell>
                        <EllipsisTableCell maxWidth="200px" title={row.content_name}>{row.content_name}</EllipsisTableCell>
                        <EllipsisTableCell maxWidth="150px" title={row.test_name}>{row.test_name}</EllipsisTableCell>
                        <TableCell>
                            {row.result === 'passed' ? t('common.yes') : t('common.no')}
                        </TableCell>
                        <TableCell>{row.achieved_points}</TableCell>
                        <TableCell>{row.max_points}</TableCell>
                    </TableRow>
                ))}
            </TableBody>
        </Table>
    </TableContainer>;
};
